import { Reducer } from 'redux';
import { ActionTypes } from '../../constants/action-types';
import { SegmentSelectAction, SelectedSegmentReducerActions } from './types';

export interface SelectedSegmentState {
  id: string;
}

export const selectedSegmentInitialState: SelectedSegmentState = {
  id: '',
};

export const SelectedSegmentReducer: Reducer<SelectedSegmentState> = (
  state = selectedSegmentInitialState,
  action: SelectedSegmentReducerActions,
): SelectedSegmentState => {
  switch (action.type) {
    case ActionTypes.SEGMENT_SELECT:
      const selectedSegment = (action as SegmentSelectAction).id.toString();
      return state.id === selectedSegment
        ? { ...state, id: '' }
        : { ...state, id: selectedSegment };
    case ActionTypes.SEGMENT_DESELECT:
      return { ...state, id: '' };
    default:
      return state;
  }
};
